
export const getInitialAppState = () => {
    return {
        tnc: {
            state: null,    //vic, nsw, sa, qld
            data: []
        },
        showNeedLogin: false,
        splashWait: {
            show: null,
            desc: null,
            descDefault: 'Stay hydrated, grab a glass of water... We are doing some ground work to fetch a perfect plan for you!'
        },
        error: {},
        loading: false,
        loadingMsg: null
    };
}
